import { SET_RECRUITERS_FEES_LIST } from './types.js'

export default {
  [SET_RECRUITERS_FEES_LIST](state, list) {
    state.recruiters_fees = list
  },
}
